<script>
import Heading from './Heading.vue';
import AddNewButton from './AddNewButton.vue';
import DeleteButton from './DeleteButton.vue';
import ActiveToggle from './ActiveToggle.vue';

export default {
  data() {
    return {
      isGlobal: false
    }
  },
  computed: {
    enableAddNewButton() {
      if(this.topbarControls?.config?.addNewButton) {
        return this.topbarControls.config.addNewButton
      }
      return this.$route?.query?.devlopermode && this.$route?.query?.devlopermode === 'true' || false
    },
    enableDeleteButton() {
       if(this.topbarControls?.config?.deleteButton && !this.isGlobal) {
        return this.topbarControls.config.deleteButton
      }
      return this.$route?.query?.devlopermode && this.$route?.query?.devlopermode === 'true' || false
    }
  },
  props: {
    attr: {
      type: Object,
      required: true,
    },
    topbarControls: {
      type: Object,
      required: true
    },
    setTopbarControls: {
      type: Function,
      required: true
    },
  },
  components: {
    Heading, AddNewButton, DeleteButton, ActiveToggle
  },
  watch: {
    topbarControls: {
      handler(val) {
        if (this.$route.params.categoryName == 'globalupdate') {
          this.isGlobal = false
        }
        else if(val.selectedItem && val.selectedItem.additionalProp1) {
          this.isGlobal = val.selectedItem.additionalProp1.global
        }
      },
      deep: true
    }
  }
};
</script>
<template>
  <div class="navbar-header mt-4 pb-4" :class="{ 'border-bottom-dark': $route.params.categoryName !== 'pcnevents' }" style="letter-spacing: 0.02em;">
    <Heading :title="attr.title" :setTopbarControls="setTopbarControls"/>
    <div class="d-flex font-size-14 h-75">
      <AddNewButton class="topbar-button" v-if="enableAddNewButton" :topbarControls="topbarControls"/>
      <DeleteButton class="topbar-button" v-if="enableDeleteButton" :topbarControls="topbarControls"/>
      <ActiveToggle class="topbar-button" v-if="topbarControls.config && topbarControls.config.activeToggle" :isGlobal="isGlobal" :topbarControls="topbarControls"/>
    </div>
  </div>
</template>


<style scoped>
  .border-bottom-dark {
    border-bottom: 1px solid #DADCE3;
  }

  .topbar-button:last-of-type {
    padding-right: 10px;
  }

  .border-right-dark:not(:last-of-type) {
    border-right: 1px solid #DADCE3;
    border-radius: 0;
    padding-right: 16px;
  }

  .vue-switcher div:after {
    height: 23px;
    width: 23px;
    left: 95%;
  }
  .btn-success {
    background-color: #62c2a7;
    border-color: #62c2a7;
  }

  .btn-edit-page {
    background-color: #F45326;
    border-color: #F45326;
  }

  .vue-switcher--bold div {
    height: 30px !important;
    width: 50px !important;
  }
  .vue-switcher--bold div:after {
      margin-left: -27px !important;
      top: 3px !important;
  }
</style>